import { createContext } from 'react';

import { AsyncDataResult } from '../hooks';
import { MaintenanceBannerData, ModalData, OpCoData } from '../models';

export interface CMSContent {
  opcos: AsyncDataResult<Array<OpCoData>>;
  maintenanceBanners: AsyncDataResult<MaintenanceBannerData[]>;
  modal: AsyncDataResult<ModalData | undefined>;
}

export const CMSProviderContext = createContext<CMSContent | undefined>(undefined);
